import { render, staticRenderFns } from "./SemiologiaEndocrino.vue?vue&type=template&id=1a8797ff"
import script from "./SemiologiaEndocrino.vue?vue&type=script&lang=js"
export * from "./SemiologiaEndocrino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports